var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnesInferior = function SvgOnesInferior(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 272,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ones_inferior_svg__a",
    width: 720,
    height: 272,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M0 0h720v272H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#18c6b5",
    mask: "url(#ones_inferior_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M719.522 288.12S398.25 286.97 258.35 133.833C125.599-11.474-26.882 2.618-26.882 2.618V288.12z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.807 288.12s-87.391-130.964-354.681-105.847S-104 79.948-104 79.948V288.12z",
    opacity: 0.35
  }))));
};
export { SvgOnesInferior as ReactComponent };